export default async ({ commit, rootGetters }) => {
    let counter = 0;

    let entry = await rootGetters['entry_video/entry']
    let main = await rootGetters['main_videos/main']
    let ending = await rootGetters['ending_video/ending']

    await entry.forEach(element => {
        counter = counter + element.duration
    });

    await main.forEach(element => {
        counter = counter + element.duration
    });

    await ending.forEach(element => {
        counter = counter + element.duration
    });

    commit('setDuration', { duration: counter })
}